<template>
  <v-layout row wrap>
    <v-flex xs5>
      <v-checkbox label="API Only Mode Enabled" v-model="apiOnly"></v-checkbox>
      <v-text-field v-model="apiUsername" label="API Username" hint="Default is kinetic_admin. Can be left blank." persistent-hint></v-text-field>
      <v-text-field v-model="apiPassword" label="API Password" hint="Leave blank to use device default password" persistent-hint></v-text-field>
    </v-flex>

    <v-flex xs1></v-flex>

    <v-flex xs5>
      <v-checkbox label="Show Device Name on Idle" v-model="showDeviceName"></v-checkbox>

      <v-text-field v-model="deviceName" label="Device Name" hint="Optional. Defaults to mp200 or vega3000." persistent-hint></v-text-field>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  name: 'OrderDetailCardBrands',
  computed: {
    apiOnly: {
      get () {
        let val = this.$store.state.order.apiOnly
        if (!this.present(val)) { val = false }
        return val
      },
      set (value) { this.$store.commit('updateOrder', ['apiOnly', value]) }
    },
    apiUsername: {
      get () { return this.$store.state.order.apiUsername },
      set (value) { this.$store.commit('updateOrder', ['apiUsername', value]) }
    },
    apiPassword: {
      get () { return this.$store.state.order.apiPassword },
      set (value) { this.$store.commit('updateOrder', ['apiPassword', value]) }
    },
    showDeviceName: {
      get () {
        let val = this.$store.state.order.showDeviceName
        if (!this.present(val)) { val = false }
        return val
      },
      set (value) { this.$store.commit('updateOrder', ['showDeviceName', value]) }
    },
    deviceName: {
      get () { return this.$store.state.order.deviceName },
      set (value) { this.$store.commit('updateOrder', ['deviceName', value]) }
    }
  },
  methods: {
    present: function (val) {
      let output = true
      if (val === undefined) { output = false }
      if (val === '') { output = false }
      if (val === 'undefined') { output = false }
      if (val === null) { output = false }
      return output
    }
  }
}
</script>

<style scoped>

</style>
